export default __webpack_public_path__ + "static/media/Downloads.cfe12576.png";